import React, { useEffect, useState } from 'react';

const Loader = (props: any) => {
     const [loading, setLoading] = useState<boolean>(true);

     useEffect(() => {
          const fetchData = async () => {
               try {
                    document.body.classList.add('Loader-start');
                    await new Promise(resolve => setTimeout(resolve, props.timer));

                    setTimeout(() => {
                         setLoading(false);
                         document.body.classList.remove('Loader-start');
                    }, 1000); // Match this to the duration of the wave-out animation
               } catch (error) {
                    console.error('Error fetching data', error);
               }
          };

          fetchData();
     }, [props.timer]);


     const texts = [
          "ॐ कृष्णाय वासुदेवाय हरये परमात्मने प्रणतः क्लेशनाशाय गोविंदाय नमो नमः",
          "ॐ नमो भगवते वासुदेवाय",
          "ॐ गं गणपतये नमः",
          "ॐ नमः शिवाय",
          "ॐ ऐं सरस्वत्यै नमः",
          "ॐ श्री महालक्ष्म्यै नमः",
          "ॐ दुं दुर्गायै नमः",
          "ॐ हनुमते नमः",
          "ॐ रामाय नमः",
          "ॐ क्लीं कृष्णाय नमः",
          "ॐ कालभैरवाय नमः",
          "ॐ नमो नारायणाय",
          "ॐ नमो भगवते रुद्राय",
          "ॐ आदित्याय विद्महे दिवाकराय धीमहि तन्नो सूर्यः प्रचोदयात्",
          "ॐ त्र्यम्बकं यजामहे सुगन्धिं पुष्टिवर्धनम्। उर्वारुकमिव बन्धनान्मृत्योर्मुक्षीय मामृतात्॥", 
          "ॐ भूर् भुवः स्वः। तत्सवितुर्वरेण्यं। भर्गो देवस्य धीमहि। धियो यो नः प्रचोदयात्॥", 
          "ॐ श्रीरामाय रामभद्राय रामचन्द्राय वेधसे। रघुनाथाय नाथाय सीतायाः पतये नमः॥",
          "ॐ सर्वमंगल मांगल्ये शिवे सर्वार्थ साधिके। शरण्ये त्र्यम्बके गौरि नारायणी नमोऽस्तुते॥",
          "ॐ वक्रतुंड महाकाय सूर्यकोटि समप्रभ। निर्विघ्नं कुरु मे देव सर्वकार्येषु सर्वदा॥",
          "ॐ शांताकारं भुजगशयनं पद्मनाभं सुरेशम्। विश्वाधारं गगनसदृशं मेघवर्णं शुभाङ्गम्॥",
          "ॐ अंगांगाय नमः",
          "ॐ अपवित्रः पवित्रो वा सर्वावस्थां गतोऽपि वा। यः स्मरेत पुण्डरीकाक्षं स बाह्याभ्यंतरः शुचिः॥",
          "ॐ नारायणाय विद्महे वासुदेवाय धीमहि। तन्नो विष्णुः प्रचोदयात्॥",
          "ॐ ह्रीं दुं दुर्गायै नमः",
          "ॐ नमः भगवते श्रीरामचन्द्राय",
          "ॐ नमो भगवते रमानुजाय",
        ];
        


     const [currentText, setCurrentText] = useState<string>("");

     useEffect(() => {
          const lastIndex = Number(localStorage.getItem("lastTextIndex")); // pichla index
          let randomIndex = Math.floor(Math.random() * texts.length);

          
          while (randomIndex === lastIndex && texts.length > 1) {
               randomIndex = Math.floor(Math.random() * texts.length);
          }

          setCurrentText(texts[randomIndex]);
          localStorage.setItem("lastTextIndex", randomIndex.toString()); // save new index
     }, []);

     return (
          <>
               {loading && (
                    <div className="__loader">
                         <div className='__content'>
                              <svg width="16px" height="12px">
                                   <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                                   <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                              </svg>
                              <div className='__txt color-txt'>
                                   <p>{currentText}</p>
                                   <h6>...</h6>
                              </div>
                         </div>
                    </div>
               )}
          </>
     );
};

export default Loader;
